__turbopack_context__.v({
  "ListItemPage__backButton": "bhXNRa_ListItemPage__backButton",
  "ListItemPage__keyvisual": "bhXNRa_ListItemPage__keyvisual",
});
